import {
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState/onboardingState.ts';
import { useRouteName } from '@confluence/route-manager/entry-points/RouteState.ts';
import { WIKI, HOME } from '@confluence/named-routes/entry-points/routes.ts';
import { HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';
import { useNthUserOrientationState } from '@confluence/experiment-nth-user-orientation/entry-points/useNthUserOrientationStore.ts';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

export const useIsEligibleForNthUserHomeOnboardingTakeoverV2HomeNudge = ({
	skip = false,
}: {
	skip?: boolean;
} = {}):
	| {
			isEligibleForHomeNudge: boolean;
			isOnHome: boolean;
			loading: boolean;
			error: ApolloErrorInterop | undefined;
			isHomeNudgeScheduledAt?: undefined;
	  }
	| {
			isEligibleForHomeNudge: boolean;
			isHomeNudgeScheduledAt: any;
			isOnHome: false;
			loading: false;
			error: undefined;
	  } => {
	const isOnHomeOrWikiRouteArgs = {
		selector: (routeName: string | undefined) => {
			if (!routeName) {
				return false;
			}
			return routeName === WIKI.name || routeName === HOME.name;
		},
	};
	const isOnHome = useRouteName(isOnHomeOrWikiRouteArgs);

	const { active: isNthUserOrientationActive } = useNthUserOrientationState();

	const localSkip = skip || isOnHome || isNthUserOrientationActive;

	const { data, loading, error } = useGetOnboardingState(
		Object.values(HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS),
		localSkip,
	);

	const { hasSeenHomeNudge, takeoverSeenAt, hasDismissedTakeover, isHomeNudgeScheduledAt } =
		deserializeState(data);

	if (localSkip || loading || error) {
		return {
			isEligibleForHomeNudge: false,
			isOnHome,
			loading,
			error,
		};
	}

	return {
		isEligibleForHomeNudge: Boolean(!hasSeenHomeNudge && !takeoverSeenAt && !hasDismissedTakeover),
		isHomeNudgeScheduledAt,
		isOnHome,
		loading,
		error,
	};
};
